// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ContextMenu_toggleButton__21-Pu","menu":"ContextMenu_menu__1VXbc","menuItem":"ContextMenu_menuItem__3dw8L","menuItemIcon":"ContextMenu_menuItemIcon__2k5Cq"};